export default "__VITE_ASSET__CmtFGykR__"